import React, { useEffect, useState } from 'react';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import { getAmazonData } from '../middleware/getAmazonData';
import Loading from '../components/Loading';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function VerifyProduct() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const productLink = queryParams.get('productLink');

    const [productData, setProductData] = useState(null);
    const [hitPrice, setHitPrice] = useState('');
    const [error, setError] = useState(null);

    const navigate = useNavigate();

    useEffect(() => {
        function extractProductID(url) {
            const match = url.match(/\/dp\/([A-Z0-9]+)/);
            return match ? match[1] : null;
        }

        const fetchProductData = async () => {
            if (productLink) {
                const productId = extractProductID(productLink);
                const data = await getAmazonData(productId);
                if (data) {
                    setProductData(data);
                } else {
                    setError("Failed to fetch product data.");
                }
            }
        };
        fetchProductData();
    }, [productLink]);

    const handleTrackProduct = async () => {
        if (!hitPrice) {
            alert("Please enter a target price.");
            return;
        }

        const token = localStorage.getItem("token");

        const requestBody = {
            productTitle: productData.title,
            productLink: productData.product_url,
            currentPrice: productData.deal_price,
            hitPrice: hitPrice,
            category: productData.category,
            imageLink: productData.image_url
        };

        try {
            const response = await fetch('http://localhost:5000/api/trackProduct', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(requestBody)
            });

            const result = await response.json();

            if (response.ok) {
                toast.success('Product Tracking Successful');
                setTimeout(() => {
                    navigate("/trackinglist");
                }, 2000);
            } else {
                setError(result.message || "Error tracking product.");
            }
        } catch (err) {
            toast.error('Product Tracking Failed');
            console.error("Error tracking product:", err);
            setError("Failed to track product.");
        }
    };

    if (error) {
        return (
            <div className='flex flex-col items-center justify-center p-8 gap-4 font-inter text-center'>
                <ToastContainer />
                <p className='text-lg font-medium text-red-600'>
                    So, this happened while fetching information about your Product: <b>{error}</b>
                </p>
                <Link to='/addProduct' className='bg-black hover:bg-gray-700 text-white font-bold py-2 px-4 rounded'>
                    Try Again
                </Link>
            </div>
        );
    }

    if (!productData) {
        return (
            <div className='flex flex-col items-center justify-center p-8'>
                <Loading />
            </div>
        );
    }

    const { title, deal_price: currentPrice, original_price: originalPrice, discount: currentDiscount } = productData;

    return (
        <div className='font-inter flex flex-col items-center px-4 py-10 max-w-xl mx-auto text-center'>
            <ToastContainer />

            <h1 className='text-3xl font-bold mb-4'>Verifying Product</h1>

            <div className='bg-white shadow-md rounded-lg p-6 w-full text-left space-y-4'>
                <p className='text-sm text-gray-500 break-words'>
                    <span className='font-medium'>Product Link:</span> {productLink}
                </p>
                <p><span className='font-semibold'>Title:</span> {title}</p>
                <p><span className='font-semibold'>Current Price:</span> ₹{currentPrice}</p>
                <p><span className='font-semibold'>Original Price:</span> ₹{originalPrice}</p>
                <p><span className='font-semibold'>Discount:</span> {currentDiscount}%</p>
            </div>

            <div className='mt-8 w-full bg-white shadow-sm rounded-lg p-6'>
                <h2 className='text-lg font-medium mb-2'>Set Your Target Price</h2>
                <p className='text-sm mb-4 text-gray-600'>We'll notify you when the product hits this price or lower.</p>

                <div className='flex flex-col sm:flex-row items-center justify-center gap-4'>
                    <input
                        type='number'
                        id='hit-price'
                        className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-black focus:border-black block w-32 p-2.5'
                        placeholder='₹'
                        value={hitPrice}
                        onChange={(e) => setHitPrice(e.target.value)}
                    />
                    <button
                        type='button'
                        onClick={handleTrackProduct}
                        className='bg-black hover:bg-gray-700 text-white font-bold py-2 px-6 rounded'
                    >
                        Track
                    </button>
                </div>
            </div>
        </div>
    );
}

export default VerifyProduct;
